"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsTitleTextBox = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _FormTextbox = require("../../FormTextbox");
var _underscore = require("underscore");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SettingsTitleTextBox = exports.SettingsTitleTextBox = function SettingsTitleTextBox(_ref) {
  var user = _ref.user,
    isDisabled = _ref.isDisabled,
    handleFirstNameChange = _ref.handleFirstNameChange,
    handleLastNameChange = _ref.handleLastNameChange;
  var _useState = (0, _react.useState)(user === null || user === void 0 ? void 0 : user.firstName),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    firstName = _useState2[0],
    setFirstName = _useState2[1];
  var _useState3 = (0, _react.useState)(user === null || user === void 0 ? void 0 : user.lastName),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    lastName = _useState4[0],
    setLastName = _useState4[1];
  var handleNameChange = function handleNameChange(value, setField, nameChangeHandler) {
    var debounce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    setField(value);
    if (debounce) {
      debouncedHandleNameChange(value, nameChangeHandler);
    } else {
      nameChangeHandler(value);
    }
  };
  var debouncedHandleNameChange = (0, _react.useMemo)(function () {
    return (0, _underscore.debounce)(function (value, nameChangeHandler) {
      nameChangeHandler(value);
    }, 300);
  }, [handleFirstNameChange, handleLastNameChange]);
  var hasFirstNameExceededLimit = (firstName === null || firstName === void 0 ? void 0 : firstName.trim().length) > 30;
  var hasLastNameExceededLimit = (lastName === null || lastName === void 0 ? void 0 : lastName.trim().length) > 50;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "firstName",
    id: "firstName",
    labelText: "First name",
    value: firstName,
    required: true,
    onChange: function onChange(event) {
      return handleNameChange(event.target.value, setFirstName, handleFirstNameChange);
    },
    onBlur: function onBlur(event) {
      return handleNameChange(event.target.value, setFirstName, handleFirstNameChange, false);
    },
    disabled: isDisabled,
    hasError: hasFirstNameExceededLimit,
    errorMessage: hasFirstNameExceededLimit && "First Name can't exceed 30 characters"
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_FormTextbox.FormTextbox, {
    "data-testid": "lastName",
    id: "lastName",
    labelText: "Last name",
    value: lastName,
    required: true,
    onChange: function onChange(event) {
      return handleNameChange(event.target.value, setLastName, handleLastNameChange);
    },
    onBlur: function onBlur(event) {
      return handleNameChange(event.target.value, setLastName, handleLastNameChange, false);
    },
    disabled: isDisabled,
    hasError: hasLastNameExceededLimit,
    errorMessage: hasLastNameExceededLimit && "Last Name can't exceed 50 characters"
  })));
};